import * as actionTypes from './actionTypes';
import * as actions from './index';

export const addObjToCart = (obj) => {
    const objs = Array.isArray(obj) ? obj : [obj];
    console.log(objs);
    return {
        type: actionTypes.ADD_OBJ_TO_CART,
        objs: objs
    };
};

export const removeObjFromCart = (obj) => {
    const objs = Array.isArray(obj) ? obj : [obj];
    console.log(objs);
    return {
        type: actionTypes.REMOVE_OBJ_FROM_CART,
        objs: objs
    };
};

export const removeAllObjFromCart = () => {
    return {
        type: actionTypes.REMOVE_ALL_OBJ_FROM_CART
    };
};

export const addSelectedToCart = (clips) => {
    return {
        type: actionTypes.ADD_SELECTED_TO_CART,
        payload: {clips: clips }
    };
};

export const addSingleToCart = (clipId) => {
    return {
        type: actionTypes.ADD_CLIP_TO_CART,
        payload: { id: clipId }
    }
}

export const removeSingleFromCart = (clipId) => {
    return {
        type: actionTypes.REMOVE_CLIP_FROM_CART,
        payload: { id: clipId }
    }
}

export const emptyCart = () => {
    return {
        type: actionTypes.EMPTY_CART
    };
};

const copyCartStart = () => {
    return {
        type: actionTypes.COPY_CART_START
    }
}

const copyCartSuccess = (project, pType = 'project') => {
    return {
        type: actionTypes.COPY_CART_SUCCESS,
        payload: {project: project, type: pType}
    }
}

const copyCartFail = (error) => {
    return {
        type: actionTypes.COPY_CART_FAIL,
        error: error
    }
}

export const donwloadMediafiles = (ids = []) => {
    console.log(ids);
    return (dispatch) => {
        dispatch({ type: actionTypes.CART_DOWNLOAD_MF_START });
        window.flow.zipByMfids(ids).then((res) => {
            dispatch({ type: actionTypes.CART_DOWNLOAD_MF_SUCCESS });
        }).catch(res => {
            dispatch({ type: actionTypes.CART_DOWNLOAD_MF_FAIL });
        });
    };
};

export const copyCartAsRoom = (name) => {
    return( (dispatch, getState) => {
        const cliplist = getState().cart.clipsInCart;
        let clips = cliplist ? cliplist.join() : null;
		if(clips) {
			dispatch(copyCartStart());
			window.flow.newShowroom({title: name}).then(res => {
				window.flow.projectAddClip(res.id, clips, 'forceadd').then((r1) => {
					console.log(r1);
					dispatch(copyCartSuccess(res, 'room'));
					dispatch(actions.getRooms());
				});
				
			}).catch(res => {
				dispatch(copyCartFail(res.message));
				dispatch(actions.applicationError(res.message));
			});			
		}
    });
}

export const copyCartAsProject = (name) => {
    return( (dispatch, getState) => {
        const cliplist = getState().cart.clipsInCart;
        let clips = cliplist ? cliplist.join() : null;
		if(clips) {
			dispatch(copyCartStart());
			window.flow.newProject({name: name}).then(res => {
				// projects allways private
				window.flow.projectSetPrivate(res.id);
				window.flow.projectAddClip(res.id, clips, 'forceadd').then((r1) => {
					console.log(r1);
					dispatch(copyCartSuccess(res, 'project'));
					// reload projects and  project tree
					dispatch(actions.getProjectTree());
					dispatch(actions.getProjects());
				});
				
			}).catch(res => {
				dispatch(copyCartFail(res.message));
				dispatch(actions.applicationError(res.message));
			});			
		}
    });
}
